import { RunStatus } from "@kaggle/components";
import { Kaggle } from "@kaggle/sdk";

export interface ResourceUsage {
  cpu: { pct: number };
  ram: { usage: number; limit: number };
  disk: { usage: number; limit: number };
  hostDisk: { usage: number; limit: number };
  gpu?: { pct: number };
  gpuMemory?: { usage: number; limit: number };
  tpu?: { pct: number };
  tpuIdle?: { pct: number };
  acceleratorEverUtilized?: { everUtilized: boolean };
}

export type RunLog = Kaggle.Sdk.Kernels.Models.KernelRunLog;

export interface Run {
  id: number;
  status: RunStatus;
  exitCode?: number;
  resourceUsage: ResourceUsage | null;
  logs: RunLog[] | null;
  // Track the versionId the run belongs to (debugging purposes for now).
  versionId?: number;
  stdOut: { key: number; value: string }[];
  stdErr: { key: number; value: string }[];
  datasetDownloadProgressMessages: string[];
  dateCreated: string | null;
}

export interface RunDetails {
  runId: number;
  status: RunStatus;
  baseUrl: string;
  isPrivate: boolean;
}

export function stringToRunStatus(str: string): RunStatus {
  switch (str) {
    case "queued":
      return "queued";
    case "running":
      return "running";
    case "error":
      return "error";
    case "cancelRequested":
      return "cancelRequested";
    case "cancelAcknowledged":
      return "cancelAcknowledged";
    case "complete":
      return "complete";
    case "newScript":
      return "newScript";
    default:
      throw new Error(`${str} is not a valid RunStatus.`);
  }
}

export function runStatusToString(status: RunStatus) {
  switch (status) {
    case "queued":
      return "Queued";
    case "running":
      return "Running";
    case "error":
      return "An error occurred";
    case "cancelRequested":
      return "Cancelling...";
    case "cancelAcknowledged":
      return "Cancelled";
    case "complete":
      return "Complete";
    case "newScript":
      return "New Run";
    default:
      return "Unknown";
  }
}

export function runStatusToColor(status: RunStatus) {
  switch (status) {
    case "queued":
      return "#F9CF51";
    case "running":
      return "#42E3BB";
    case "error":
      return "#F58B8A";
    case "cancelRequested":
      return "#FDAA5C";
    default:
      return "rgba(0,0,0,0.4)";
  }
}
